import type {AnalysisResult} from './analysis';

export type EvidenceLevel='observed'|'limited'|'estimated'|'unavailable';
export type EvidenceItem={id:string;name:string;level:EvidenceLevel;explanation:string;observedAt:string|null};

/**
 * Coverage and provenance are NOT a model accuracy percentage.
 * These checks never claim prediction validation without benchmark truth.
 */
export function evaluateEvidence(result:AnalysisResult):EvidenceItem[]{
  const timestamp=result.metrics?.observedAt||result.completedAt||null;
  const catalog=result.catalog;
  const shopify=result.website.technology?.platform==='Shopify';
  const catalogVerified=!!catalog&&result.modules.catalog?.status==='success'&&(shopify?catalog.catalogComplete===true:catalog.count>=0);
  const profiles=result.social?.profiles||[];
  const profilesWithCounts=profiles.filter(p=>p.followers!=null&&p.handle);
  const allSerp=profilesWithCounts.length>0&&profilesWithCounts.every(p=>(p.collectionMethod||'').includes('google_serp_public_snippets'));
  const metrics=result.metrics;
  const baseVisible=result.modules.website?.status==='success';
  return [
    {
      id:'website',name:'官网及技术',level:baseVisible?'observed':'limited',
      explanation:baseVisible?'官网页面可访问；技术栈从公开页面识别。':'官网访问受限，已采集的信息不代表完整网站。',
      observedAt:baseVisible?(result.website.observedAt||null):null
    },{
      id:'catalog',name:'商品目录',level:catalogVerified?'observed':catalog?'limited':'unavailable',
      explanation:catalogVerified?'本次已成功取得完整公开商品目录。':catalog?'这是部分结果或带日期的已缓存商品观测；不能视为本次实时商品总数。':'未取得可验证的最新商品目录。',
      observedAt:catalog?(result.modules.catalog?.status==='partial'?result.website.observedAt||timestamp:timestamp):null
    },{
      id:'social',name:'社媒粉丝',level:profilesWithCounts.length?(allSerp?'limited':'observed'):'unavailable',
      explanation:profilesWithCounts.length?(allSerp?'仅来自搜索摘要；可能过时，请以社媒资料页为准。':'取得与账号关联的公开社媒数字；并非平台后台授权数据。'):'无法验证粉丝数，空值不等于零。',
      observedAt:profilesWithCounts.length?(result.social?.observedAt||timestamp):null
    },{
      id:'traffic',name:'月流量',level:metrics?.traffic?'estimated':'unavailable',
      explanation:metrics?.traffic?('模型 '+metrics.traffic.modelVersion+' 的区间估计，尚无已发布的真实误差校准结果；评分不是准确率。'):'本次没有可验证的月流量估计。',
      observedAt:metrics?.traffic?timestamp:null
    },{
      id:'revenue',name:'月营收',level:metrics?.revenue?'estimated':'unavailable',
      explanation:metrics?.revenue?('模型 '+metrics.revenue.modelVersion+' 的场景推算，AOV/CVR 未必是实际经营值，不能等同真实销售额。'):'本次没有可验证的月营收估计。',
      observedAt:metrics?.revenue?timestamp:null
    },{
      id:'ads',name:'广告花费',level:'unavailable',
      explanation:'公开广告创意/活跃信号不等于真实广告支出；没有可靠来源时不显示金额。',
      observedAt:null
    }
  ];
}
